import React from "react";

const Badge = ({ text, className }) => {
  let badgeColor = "bg-redBorder";

  switch (text) {
    case "For Sale":
      badgeColor = "bg-redBorder";
      break;

    case "Bargain":
      badgeColor = "bg-primary";
      break;

    case "Rent me":
      badgeColor = "bg-badgeYellow";
      break;

    case "Look Here":
      badgeColor = "bg-badgeGreen";
      break;

    case "Buy me":
      badgeColor = "bg-badgeRed";
      break;

    case "Best Deal":
      badgeColor = "bg-blue";
      break;

    default:
      badgeColor = "bg-redBorder";
  }
  return (
    <div
      className={`py-.5 absolute top-3 -left-6 inline-block origin-center -rotate-45 px-7 font-pop text-[9px] text-white ${className} ${badgeColor}`}
    >
      {text}
    </div>
  );
};

export default Badge;
